import { HRMSManagerPermissionEnum, HighestEducationEnum, ManagerPermissionEnum } from '../../types/auth';
import { EmployeeJoinStatusEnum } from '../../types/employee';
import { AutomaticReminderEnum, OfferStateEnum } from '../../types/offer';
import { HRMSDomainStatusEnum, InviteStatusEnum, InviteTypeEnum } from '../../types/invitations';
import { ReviewType } from '../../types/review';

export const getHighestEducation = (value: HighestEducationEnum) => {
    switch (value) {
        case HighestEducationEnum.HighSchoolDiploma:
            return 'Highest School Diploma';
        case HighestEducationEnum.AssociateDegree:
            return "Associate's Degree";
        case HighestEducationEnum.BachelorsDegree:
            return "Bachelor's Degree";
        case HighestEducationEnum.MastersDegree:
            return "Master's Degree";
        case HighestEducationEnum.DoctorateDegree:
            return 'Doctorate Degree';
        default:
            return 'Unkown';
    }
};

export const getPermissionText = (value: ManagerPermissionEnum) => {
    switch (value) {
        case ManagerPermissionEnum.admin:
            return 'Admin';
        case ManagerPermissionEnum.offerManager:
            return 'Offer manager';
        case ManagerPermissionEnum.owner:
            return 'Owner';
        default:
            return 'unknown';
    }
};
export const getHRMSPermissionText = (value: HRMSManagerPermissionEnum) => {
    switch (value) {
        case HRMSManagerPermissionEnum.admin:
            return 'Admin';
        case HRMSManagerPermissionEnum.hrms:
            return 'HRMS';
        default:
            return 'unknown';
    }
};

export const getJoinStatusText = (value: EmployeeJoinStatusEnum) => {
    switch (value) {
        case EmployeeJoinStatusEnum.pending:
            return 'Pending';
        case EmployeeJoinStatusEnum.joined:
            return 'Joined';
        case EmployeeJoinStatusEnum.deleted:
            return 'Deleted';
        default:
            return 'unknown';
    }
};

export const getInviteStatusText = (value: InviteStatusEnum) => {
    switch (value) {
        case InviteStatusEnum.invited:
            return 'Invited';
        case InviteStatusEnum.joined:
            return 'Joined';
        case InviteStatusEnum.deleted:
            return 'Deleted';
        case InviteStatusEnum.elsewhere:
            return 'Joined elsewhere';
        default:
            return 'unknown';
    }
};

export const getHRMSStatusText = (value: HRMSDomainStatusEnum) => {
    switch (value) {
        case HRMSDomainStatusEnum.active:
            return 'Active';
        case HRMSDomainStatusEnum.inactive:
            return 'Inactive';
        default:
            return 'unknown';
    }
};

export const getOfferStateText = (value: OfferStateEnum) => {
    switch (value) {
        case OfferStateEnum.pending:
            return 'pending';
        case OfferStateEnum.accepted:
            return 'accepted';
        case OfferStateEnum.rejected:
            return 'declined';
        case OfferStateEnum.retracted:
            return 'retracted';
        case OfferStateEnum.expired:
            return 'expired';
        default:
            return 'unknown';
    }
};

export const getAutomaticReminderText = (value: AutomaticReminderEnum) => {
    switch (value) {
        case AutomaticReminderEnum.never:
            return 'Never';
        case AutomaticReminderEnum.every1Day:
            return 'Every 1 day';
        case AutomaticReminderEnum.every2Day:
            return 'Every 2 days';
        case AutomaticReminderEnum.every3Day:
            return 'Every 3 days';
        case AutomaticReminderEnum.every1Week:
            return 'Every 1 week';
        default:
            return 'unknown';
    }
};

export const getReviewTypeText = (value: ReviewType) => {
    switch (value) {
        case ReviewType.OnboardingReview:
            return 'Onboarding review';
        case ReviewType.ProgressReview:
            return 'Performance review';
        case ReviewType.ExitReview:
            return 'Offboarding review';
        case ReviewType.EditReview:
            return 'Edit Onboarding review';
    }
};

export const getCandidateReviewTypeText = (value: ReviewType) => {
    switch (value) {
        case ReviewType.OnboardingReview:
            return 'Onboarding review';
        case ReviewType.ProgressReview:
            return 'Employment review';
        case ReviewType.ExitReview:
            return 'Offboarding review';
    }
};

export const getCandidateInviteTypeText = (value: InviteTypeEnum) => {
    switch (value) {
        case InviteTypeEnum.newCandidate:
            return 'New Candidate';
        case InviteTypeEnum.existingEmployee:
            return 'Existing Employee';
        case InviteTypeEnum.external:
            // return 'External';
            return 'New Candidate';
    }
};
